import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['enable', 'article', 'articlesHeading'];

  connect() {
    this.enableHandler();
  }

  enableHandler() {
    if (this.enableTarget.checked) {
      this.articlesHeadingTarget.classList.remove('text-black/40');
      this.enableArticles();
    } else {
      this.articlesHeadingTarget.classList.add('text-black/40');
      this.disableArticles();
    }
  }

  enableArticles() {
    this.articleTargets.forEach((target) => {
      target.disabled = false;
    });
  }

  disableArticles() {
    this.articleTargets.forEach((target) => {
      target.disabled = true;
      target.value = null;
    });
  }
}
